module.exports = __webpack_public_path__ + "img/History(Button).d5be3971.svg";